import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;

const EmptyAvailability = ({ togglePopup }) => {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M31.1667 7.33329H34.8333C36.8555 7.33329 38.5 8.97779 38.5 11V36.6666C38.5 38.6888 36.8555 40.3333 34.8333 40.3333H9.16667C7.1445 40.3333 5.5 38.6888 5.5 36.6666V11C5.5 8.97779 7.1445 7.33329 9.16667 7.33329H12.8333V3.66663H16.5V7.33329H27.5V3.66663H31.1667V7.33329ZM9.16667 36.6666H34.837L34.8344 18.3333H9.16667V36.6666ZM9.16667 14.6666H34.8333V11H9.16667V14.6666Z"
                        fill="#C4C4C4"
                    />
                    <path
                        d="M22 22.9166C22.7594 22.9166 23.375 23.5322 23.375 24.2916V28.4166L26.7917 28.4166C27.5511 28.4166 28.1667 29.0322 28.1667 29.7916C28.1667 30.551 27.5511 31.1666 26.7917 31.1666H22C21.2406 31.1666 20.625 30.551 20.625 29.7916V24.2916C20.625 23.5322 21.2406 22.9166 22 22.9166Z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Set up your Business Availability
            </CreateText>

            <div
                style={{
                    textAlign: 'center',
                    maxWidth: '500px',
                    marginBottom: '32px',
                    color: '#666',
                    fontSize: '16px',
                    lineHeight: '1.5',
                    fontFamily: 'Poppins, sans-serif',
                }}
            >
                Configure when your business accepts appointments. Set up your default consultation
                services and manage availability slots that patients can book online.
            </div>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Add Availability
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
};

export default EmptyAvailability;
